var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import AvisoInput from "./input";
// @ts-expect-error - TS7006 - Parameter 'place' implicitly has an 'any' type. | TS7006 - Parameter 'item' implicitly has an 'any' type.
const extractItemFromGoogleAddressObject = (place, item) => {
    let value = "";
    // @ts-expect-error - TS7006 - Parameter 'it' implicitly has an 'any' type.
    place.address_components.forEach((it) => {
        const addressType = it.types[0];
        if (addressType === item) {
            value = it.long_name;
        }
    });
    return value;
};
class AvisoForm extends PureComponent {
    constructor(props) {
        super(props);
        this.renderInputProp = this.renderInputProp.bind(this);
        this.renderFormRow = this.renderFormRow.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        const data = {};
        this.props.form.forEach((it) => {
            it.forEach((x) => {
                data[x.property] = x.value || x.defaultValue;
            });
        });
        this.state = {
            data,
            form: this.props.form,
            editedFields: [],
        };
        this.hydrateOptions(this.props.form);
    }
    onSubmit(event) {
        event.preventDefault();
        const data = Object.assign({}, this.state.data);
        const { form } = this.props;
        let isValid = true;
        // @ts-expect-error - TS7034 - Variable 'editedFields' implicitly has type 'any[]' in some locations where its type cannot be determined.
        const editedFields = [];
        form.forEach((x) => {
            x.forEach((y) => {
                editedFields.push(y.property);
                if (!this.isValid(data[y.property], y)) {
                    isValid = false;
                    console.log(`${y.property} has an invalid value of ${data[y.property]}`);
                }
            });
        });
        // @ts-expect-error - TS7005 - Variable 'editedFields' implicitly has an 'any[]' type.
        this.setState({ editedFields });
        if (isValid) {
            this.props.onSubmit(this.state.data, event);
        }
        else {
            this.setState({ data });
            if (this.props.onError) {
                this.props.onError(data, event);
            }
        }
    }
    loadOptions(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!item.optionURL || item.options) {
                return item;
            }
            const response = yield fetch(item.optionURL, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const result = yield response.json();
            item.options = [{ id: "", name: "" }, ...result];
            this.forceUpdate();
            return item;
        });
    }
    hydrateOptions(form) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const it of form) {
                for (const x of it) {
                    this.loadOptions(x);
                }
            }
        });
    }
    onChange(input, value, event) {
        if (!this.state.data) {
            return;
        }
        const data = Object.assign({}, this.state.data);
        // If this is a select box, itll have options
        if (input.options) {
            /* eslint-disable eqeqeq */
            const objectValue = input.options.find((x) => x.id == value);
            /* eslint-enable */
            if (objectValue) {
                data[input.property] = objectValue;
            }
            else {
                data[input.property] = value;
            }
        }
        else if (input.type === "googleAddress") {
            data[input.property] = Object.assign({}, data[input.property]);
            if (typeof value === "object") {
                data[input.property].address = `${extractItemFromGoogleAddressObject(value, "street_number")} ${extractItemFromGoogleAddressObject(value, "route")}`;
                data[input.property].city = extractItemFromGoogleAddressObject(value, "locality");
                data[input.property].zip = extractItemFromGoogleAddressObject(value, "postal_code");
                data[input.property].state = extractItemFromGoogleAddressObject(value, "admistrative_area_level_1");
                data[input.property].lat = value.geometry.location.lat();
                data[input.property].lng = value.geometry.location.lng();
                data[input.property].value = value.formatted_address;
            }
            else {
                if (!value) {
                    data[input.property].address = {};
                }
                data[input.property].value = value;
            }
        }
        else {
            if (input.onValueChange) {
                value = input.onValueChange(value);
            }
            data[input.property] = value;
        }
        let { editedFields } = this.state;
        if (!this.state.editedFields.find((z) => z === input.property)) {
            // lets track which values have been edited so we can show warning if they are not valid
            editedFields = [...this.state.editedFields, input.property];
        }
        this.setState({ data, editedFields });
    }
    renderFormRow(x) {
        let val = this.state.data[x.property];
        if (typeof val === "undefined") {
            val = "";
        }
        const validate = !!this.state.editedFields.find((z) => z === x.property);
        const data = Object.assign(Object.assign({}, x), { key: x.property, currentValue: val, invalid: validate && !this.isValid(val, x), onChange: this.onChange });
        let shouldShow = true;
        if (typeof x.shouldShow === "function") {
            // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean'.
            shouldShow = this.props.currentTab
                ? x.shouldShow(this.state.data, this.props.currentTab)
                : x.shouldShow(this.state.data);
        }
        return shouldShow && _jsx(AvisoInput, Object.assign({}, data));
    }
    isValid(val, input) {
        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
        let isValid = (v, i) => v || !i.isRequired;
        if (input.isValid) {
            isValid = input.isValid;
        }
        return isValid(val, input);
    }
    renderInputProp(x) {
        return _jsx("div", { children: x.map(this.renderFormRow) }, `${x[0].property}Row`);
    }
    render() {
        return (_jsxs("form", { className: this.props.className, children: [this.props.form.map(this.renderInputProp), _jsxs("button", { className: "btn btn-primary my-3", 
                    // @ts-expect-error - TS2322 - Type '(event: Event) => void' is not assignable to type 'MouseEventHandler<HTMLButtonElement>'.
                    onClick: this.onSubmit, type: "submit", children: [_jsx("span", { className: "fa fa-save fa-fw", "aria-hidden": "true" }), " Save"] }), this.props.cancelLink && (_jsxs("a", { className: "btn btn-danger my-3 ml-3", href: this.props.cancelLink, children: [_jsx("span", { className: "fa fa-times", "aria-hidden": "true" }), " Cancel"] }))] }));
    }
}
export default AvisoForm;
